var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import { useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ROUTER_URL } from '../../router/constants';
import { ErrorMessageBox } from '../common';
import { resolveExceptionMessage } from './common/resolveExceptionMessage';
import { waitForApiSliceTerminal } from './common/waitForApiSliceTerminal';
import { ORG_CONFIG_STEPS } from './constants';
import { OrgConfigWizardContext } from './context';
import { useFinalizeVersionAPI, useLocationsAPI } from './selectors';
var ActionRow = function (_a) {
  var children = _a.children;
  return _jsx(Stack, __assign({
    direction: "row",
    spacing: 4,
    justifyContent: "flex-end"
  }, {
    children: children
  }));
};
var PreviousButton = function (_a) {
  var stepIndex = _a.stepIndex,
    isSaving = _a.isSaving,
    onPrevious = _a.onPrevious,
    label = _a.label;
  return stepIndex > 0 ? _jsx(LoadingButton, __assign({
    variant: "outlined",
    onClick: onPrevious,
    disabled: isSaving,
    loading: isSaving
  }, {
    children: label
  })) : null;
};
var NextButton = function (_a) {
  var disabled = _a.disabled,
    isSaving = _a.isSaving,
    onNext = _a.onNext,
    label = _a.label;
  return _jsx(LoadingButton, __assign({
    variant: "contained",
    onClick: onNext,
    disabled: disabled,
    loading: isSaving
  }, {
    children: label
  }));
};
var FinishButton = function (_a) {
  var isSaving = _a.isSaving,
    onFinish = _a.onFinish,
    label = _a.label;
  return _jsx(LoadingButton, __assign({
    variant: "contained",
    onClick: onFinish,
    loading: isSaving
  }, {
    children: label
  }));
};
export var OrgConfigActions = function (_a) {
  var _b, _c;
  var _d = _a === void 0 ? {} : _a,
    topVariant = _d.topVariant;
  var t = useTranslation().t;
  var navigate = useNavigate();
  var store = useStore();
  var _e = useContext(OrgConfigWizardContext),
    stepIndex = _e.stepIndex,
    goToStep = _e.goToStep,
    configVersionId = _e.configVersionId,
    beforeNext = _e.beforeNext,
    isSaving = _e.isSaving,
    setIsSaving = _e.setIsSaving,
    isViewOnly = _e.isViewOnly,
    allowExit = _e.allowExit;
  var locationsData = useLocationsAPI(configVersionId)[0];
  var _f = useFinalizeVersionAPI(),
    finalizeVersion = _f[1];
  var _g = useState(null),
    finalizeError = _g[0],
    setFinalizeError = _g[1];
  var stepsLength = ORG_CONFIG_STEPS.length;
  var locations = (_c = (_b = locationsData.data) === null || _b === void 0 ? void 0 : _b.locations) !== null && _c !== void 0 ? _c : [];
  var isLocationsStep = stepIndex === 0;
  var isLastStep = stepIndex === stepsLength - 1;
  var canProceedFromLocations = locations.length >= 1;
  var isNextDisabled = isLocationsStep && !canProceedFromLocations || isSaving;
  var finalizeErrors = useMemo(function () {
    return finalizeError ? [{
      message: finalizeError
    }] : [];
  }, [finalizeError]);
  var runBeforeNext = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!beforeNext) return [2 /*return*/, true];
            setIsSaving(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1,, 3, 4]);
            return [4 /*yield*/, beforeNext()];
          case 2:
            return [2 /*return*/, _a.sent()];
          case 3:
            setIsSaving(false);
            return [7 /*endfinally*/];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  var handleNext = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, runBeforeNext()];
          case 1:
            if (_a.sent()) goToStep(stepIndex + 1);
            return [2 /*return*/];
        }
      });
    });
  };
  var handlePrevious = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, runBeforeNext()];
          case 1:
            if (_a.sent()) goToStep(stepIndex - 1);
            return [2 /*return*/];
        }
      });
    });
  };
  var handleFinish = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var ok, slice;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setFinalizeError(null);
            return [4 /*yield*/, runBeforeNext()];
          case 1:
            if (!_a.sent()) return [2 /*return*/];
            setIsSaving(true);
            _a.label = 2;
          case 2:
            _a.trys.push([2,, 4, 5]);
            return [4 /*yield*/, waitForApiSliceTerminal(store, 'orgConfigVersionFinalize:POST', finalizeVersion)];
          case 3:
            ok = _a.sent();
            if (!ok) {
              slice = store.getState().api['orgConfigVersionFinalize:POST'];
              setFinalizeError(resolveExceptionMessage(slice === null || slice === void 0 ? void 0 : slice.error, t, t('error.internalError', {
                defaultValue: 'Failed to finalize configuration.'
              })));
              return [2 /*return*/];
            }
            return [3 /*break*/, 5];
          case 4:
            setIsSaving(false);
            return [7 /*endfinally*/];
          case 5:
            if (allowExit) allowExit.current = true;
            navigate("".concat(ROUTER_URL.Organization, "?configured=1"));
            return [2 /*return*/];
        }
      });
    });
  };
  if (isViewOnly) {
    return _jsx(ActionRow, {
      children: _jsx(LoadingButton, __assign({
        variant: "contained",
        onClick: function () {
          return navigate(ROUTER_URL.Home);
        },
        sx: {
          textTransform: 'uppercase'
        }
      }, {
        children: t('action.exit')
      }))
    });
  }
  var previousButton = _jsx(PreviousButton, {
    stepIndex: stepIndex,
    isSaving: isSaving,
    onPrevious: handlePrevious,
    label: t('action.previous')
  });
  var primaryButton = isLastStep ? _jsx(FinishButton, {
    isSaving: isSaving,
    onFinish: handleFinish,
    label: t('action.finish')
  }) : _jsx(NextButton, {
    disabled: isNextDisabled,
    isSaving: isSaving,
    onNext: handleNext,
    label: t('action.next')
  });
  if (topVariant && !isLastStep) {
    // Mirror the bottom PREVIOUS/NEXT pair in the step header so long steps can be
    // navigated without scrolling to the bottom of the page.
    return _jsxs(ActionRow, {
      children: [previousButton, primaryButton]
    });
  }
  if (topVariant) {
    return _jsxs(Stack, __assign({
      spacing: 1,
      alignItems: "flex-end"
    }, {
      children: [_jsx(ErrorMessageBox, {
        errors: finalizeErrors,
        onClose: function () {
          return setFinalizeError(null);
        },
        scrollTop: false,
        sx: {
          width: '100%'
        }
      }), _jsxs(ActionRow, {
        children: [previousButton, primaryButton]
      })]
    }));
  }
  return _jsxs(Stack, __assign({
    spacing: 1
  }, {
    children: [_jsx(ErrorMessageBox, {
      errors: finalizeErrors,
      onClose: function () {
        return setFinalizeError(null);
      },
      scrollTop: false
    }), _jsxs(ActionRow, {
      children: [previousButton, primaryButton]
    })]
  }));
};